import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PokitdokBenefits } from 'src/app/core/model/v2/insurance/pokidok-benefits';
import { Patient } from 'src/app/core/models/patient/patient';
import { InsurancePlanService } from 'src/app/core/services/insurancePlan.service';
import { PhysicianOptionService } from 'src/app/physician/shared/physician-option/physician-option.service';
import { PreviewImagesComponent } from '../preview-images/preview-images.component';
import { WindowLoaderService } from '../window-loader/window-loader.service';

@Component({
  selector: 'app-insurance-benefits',
  templateUrl: './insurance-benefits.component.html',
  styleUrls: ['./insurance-benefits.component.scss']
})
export class InsuranceBenefitsComponent implements OnInit {

  title: string;
  patient: Patient;
  benefits: PokitdokBenefits;

  constructor(public dialogRef: MatDialogRef<PreviewImagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private insurancePlanService: InsurancePlanService,
    private physicianOptionService: PhysicianOptionService,
    private loaderService: WindowLoaderService) {
    if (data) {
      this.title = data.documentTitle;
      this.patient = data.patient;
    }
  }

  ngOnInit() {
    this.loaderService.show();
    this.insurancePlanService.getBenefits(this.patient.id, this.physicianOptionService.getPhysician().id).subscribe(
      (ben) => {
        console.log(ben);
        this.benefits = ben;
        this.loaderService.hide();
      },
      (error) => { console.error(error); this.loaderService.hide(); }
    );
  }

  close() {
    this.dialogRef.close();
  }

}
